import ColorsStyles from '@Styles/colors.scss';
import styled from '@emotion/styled';
import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import DomStyles from '@Components/DomElements/DomElements.scss';

interface IReworkOptionColumnProps {
    onSelect: () => void;
    title: string;
    options?: any[];
    onSelectOption: (option: any) => void;
    selectedOption?: any;
}

const StyledColumn = styled('div')`
    grid-column: span 1;
    display: flex;
    flex-direction: column;

    transition-property: all;
    transition-duration: 1500ms;
    cursor: pointer;
    overflow-y: hidden;

    div {
        overflow-y: auto;
    }
`;

const StyledButton = styled('button')<{ $isSelected: boolean }>(
    ({ $isSelected }) => `
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: ${$isSelected ? '#fff' : ColorsStyles.ikeGradient3};
    padding: 4px 0;
    display: flex;
    border: none;
    background-color: ${
        $isSelected ? ColorsStyles.ikeGradient6 : 'transparent'
    };
    cursor: pointer;
    width: 100%;

    span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`
);

export const ReworkOptionColumn = (props: IReworkOptionColumnProps) => {
    const handleSelectOption = (event, option) => {
        event.stopPropagation();
        event.preventDefault();

        props.onSelectOption(option);
    };

    return (
        <StyledColumn onClick={props.onSelect}>
            <span className={DomStyles.domElLabel}>{props.title}</span>
            <div>
                {props.options?.map((o) => {
                    return (
                        <StyledButton
                            key={`${props.title}-${o.id}`}
                            onClick={(e) => handleSelectOption(e, o)}
                            $isSelected={props.selectedOption?.id === o.id}
                        >
                            <span>{o.description}</span>
                        </StyledButton>
                    );
                })}
            </div>
        </StyledColumn>
    );
};
